import {
  FADE_IN_ANIMATION,
  SLIDE_UP_ANIMATION,
} from '#app/components/Motion/constants.js';
import { animated } from '#app/components/Primitives/Animated.js';
import { css, styled } from 'styled-components';

export const DrawerScreen = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: ${theme.zIndices.bottomDrawer.backdrop};
    animation: ${FADE_IN_ANIMATION};
  `}
`;

export const DrawerWrapper = styled(animated.div)<{
  darkMode?: boolean;
  isOpen: boolean;
}>`
  ${({ darkMode = false, isOpen, theme }) => css`
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;

    transform: ${isOpen ? 'translateY(0%)' : 'translateY(100%)'};
    z-index: ${theme.zIndices.bottomDrawer.dialog};
    width: 100%;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    flex: auto;
    background: ${darkMode ? '#262626' : theme.colorsV2.white};
    overflow: hidden;
    animation: ${SLIDE_UP_ANIMATION};
    padding-bottom: env(safe-area-inset-bottom, 48px);
    margin: auto auto 0px auto;

    /* on mobile landscape, set a max-width to avoid stretching the drawer hero images */
    @media (orientation: landscape) and (max-width: ${theme.breakpoints.lg}) {
      max-width: 450px;
    }
  `}
`;

export const DrawerBody = styled.div<{
  removePaddingX?: boolean;
}>`
  ${({ removePaddingX = false }) => css`
    display: flex;
    flex: auto;
    flex-direction: column;
    overflow-y: auto;

    border-top-right-radius: inherit;
    border-top-left-radius: inherit;

    padding: ${removePaddingX ? '0px 0px 16px 0px' : '0px 8px 16px 8px'};
  `}
`;

export const DrawerHeader = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 8px;

  svg {
    flex-shrink: 0;
    margin-top: 4px;
  }
`;

export const DrawerCloseButton = styled.button<{
  isAbsolutePositioned?: boolean;
}>`
  display: flex;
  align-items: center;
  margin-left: auto;

  ${({ isAbsolutePositioned = false, theme }) => css`
    z-index: ${theme.zIndices.modal.dialog + 1};
    ${isAbsolutePositioned
      ? css`
          position: absolute;
          top: 24px;
          right: 24px;
        `
      : undefined}
  `}
`;

export const DrawerContent = styled.div<{
  removePaddingOnMobile?: boolean;
}>`
  ${({ removePaddingOnMobile = false }) => css`
    padding: ${removePaddingOnMobile ? '0' : '16px'};
  `}
`;

export const BetaTag = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colorsV2.brandWatermelon};
    color: ${theme.colorsV2.white};
    font-weight: ${theme.fontWeights.semiBold};
    font-size: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 6px;
    border-radius: 100px;
    text-transform: uppercase;
    width: 47px;
    height: 24px;
    margin-left: 8px;
  `}
`;
